//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 25/04/2025
// Version       : 1
// Description   : Lista de productos para el reporte de combustibles
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../../services/apirest";
import Navbar from "../../Navbar";
import { MaterialReactTable } from "material-react-table";
import { logEventos } from "../../../services/services";
// TABLA EN ESPAÑOL
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Box,
  Dialog,
  Typography,
  IconButton,
  Button,
  ThemeProvider,
  createTheme,
  useTheme,
  Tooltip,
} from "@mui/material";

import AgregarProducto from "./AgregarProducto";
import EditarProducto from "./EditarProducto";
import CambiarEstadoProducto from "./CambiarEstadoProducto";

// ICONOS
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";

function ProductosReporte() {
  const globalTheme = useTheme();

  const [productosReporte, setProductosReporte] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);

  //*************************************************************************************************************************************/

  const obtenerProductos = () => {
    fetch(UrlApi + "/productos_reporte")
      .then((data) => data.json())
      .then((data) => setProductosReporte(data));
  };

  useEffect(() => {
    obtenerProductos();
  }, []);

  //*************************************************************************************************************************************/

  // DIALOG PARA AGREGAR PRODUCTO
  const [dialogAgregar, setDialogAgregar] = useState(false);

  // Abrir diálogo para agregar producto
  const handleOpenAgregarProducto = () => {
    setDialogAgregar(true);
  };

  // Cerrar diálogo
  const handleCloseAgregarProducto = () => {
    setDialogAgregar(false);
  };

  //*************************************************************************************************************************************/

  // DIALOG PARA EDITAR PRODUCTO
  const [dialogEditar, setDialogEditar] = useState(false);

  // Abrir diálogo de edición
  const handleOpenEditar = (row) => {
    setProductoSeleccionado(row.original);
    setDialogEditar(true);
  };

    // Cerrar diálogo de edición
  const handleCloseEditar = () => {
    setDialogEditar(false);
    setProductoSeleccionado(null);
  };

  // Callback tras editar
  const handleProductoEditado = () => {
    handleCloseEditar();
    obtenerProductos();
  };

  //*************************************************************************************************************************************/

  // DIALOG PARA CAMBIAR ESTADO DE LAS PRODUCTOS
  const [openCambiarEstadoProducto, setOpenCambiarEstadoProducto] =
    useState(false);

  const handleOpenCambiarEstadoProducto = (row) => {
    setProductoSeleccionado(row);
    setOpenCambiarEstadoProducto(true);
  };

  const handleCloseCambiarEstadoProducto = () => {
    setOpenCambiarEstadoProducto(false);
  };

  //*************************************************************************************************************************************/
  // ----------- TABLA ---------------
  const customLocalization = {
    ...MRT_Localization_ES,
    body: {
      ...MRT_Localization_ES.body,
      noData: "No hay registros para mostrar",
    },
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "nombre",
        header: "Nombre",
        size: 150,
      },
      {
        accessorKey: "unidad",
        header: "Unidad",
        size: 100,
      },
    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
      "& .MuiSvgIcon-root": {
        color: "white", // color de los íconos
      },
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { backgroundColor: "#ffffff" },
    variant: "outlined",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default: "rgb(234, 239, 241)"

          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  //*************************************************************************************************************************************/

  // Función para actualizar los productos luego de que se guarde uno nuevo
  const handleProductoGuardado = () => {
    obtenerProductos(); // Vuelve a obtener los datos actualizados
  };


useEffect(() => {
logEventos(
"acceso al menu Combustibles",
"Productos",
"Lista Productos para el Reporte de Combustibles",
localStorage.getItem("user")
);
}, []);

  return (
    <>
      <Navbar />
      <Box
        sx={{
          marginTop: "20px",
          marginBottom: "25px",
          marginLeft: "40px",
          marginRight: "40px",
        }}
      >
        <ThemeProvider theme={tableTheme}>
          <MaterialReactTable
            columns={columns}
            data={productosReporte}
            initialState={initialState}
            positionActionsColumn="last"
            autoResetPageIndex={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableColumnActions={true}
            enableColumnFilters={false} // Desactiva filtros por columna
            enableHiding={false}
            localization={customLocalization}
            enableRowSelection={false}
            enableRowActions={true}
            enableGlobalFilter
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            muiTableBodyCellProps={({}) => ({
              align: "left",
              sx: {
                color: "black",
                borderColor: "black",
              },
            })}
            muiTableBodyRowProps={({ row }) => ({
              // Desactivo el hover default
              hover: false,
              sx: {
                // Color de la fila según su estado (Activo/inactivo)
                backgroundColor:
                  row.original.estado === 1 ? "#a4f0a8" : "#b0e0b3ff",
                color: "black",
                borderColor: "black",
                // Hover personalizado
                "&:hover": {
                  backgroundColor:
                    row.original.estado === 1
                      ? "#d1f0d1"
                      : "#f3d4d4ff"
                },
              },
            })}
            renderTopToolbarCustomActions={() => (
              <>
                <Typography variant="poster" fontSize={26}>
                  Productos para el Reporte de Combustibles
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  style={{ marginTop: "5px" }}
                  startIcon={<AddBoxOutlinedIcon />}
                  onClick={handleOpenAgregarProducto}
                >
                  Agregar Producto
                </Button>
              </>
            )}
            renderRowActions={({ row }) => (
              <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                <Tooltip
                  arrow
                  placement="left"
                  disableInteractive
                  title={
                    row.original.estado === 1
                      ? "Anular Producto"
                      : "Activar Producto"
                  }
                >
                  <IconButton
                    onClick={() =>
                      handleOpenCambiarEstadoProducto(row.original)
                    }
                  >
                    <BlockIcon
                      sx={{
                        color: row.original.estado === 1 ? "red" : "green",
                      }}
                    />
                  </IconButton>
                </Tooltip>

                <Tooltip
                  arrow
                  placement="left"
                  disableInteractive
                  title="Editar Producto"
                >
                  <IconButton
                    onClick={() => handleOpenEditar(row)}
                    color="primary"
                    disabled={row.original.estado !== 1}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          />
        </ThemeProvider>
      </Box>

      {/* AGREGAR PRODUCTO */}
      <Dialog
        fullWidth
        maxWidth={"md"}
        open={dialogAgregar}
        onClose={handleCloseAgregarProducto}
      >
        <AgregarProducto
          handleCloseAgregarProducto={handleCloseAgregarProducto} // Función para cerrar el diálogo
          onProductoGuardado={handleProductoGuardado} // Recargar tabla al guardar
        />
      </Dialog>

      {/* CAMBIAR ESTADO PRODUCTO */}
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={openCambiarEstadoProducto}
        onClose={handleCloseCambiarEstadoProducto}
      >
        <CambiarEstadoProducto
          producto={productoSeleccionado}
          handleCloseCambiarEstadoProducto={handleCloseCambiarEstadoProducto} // Función para cerrar el diálogo
          onProductoGuardado={handleProductoGuardado} // Recargar tabla al guardar
        />
      </Dialog>

      {/* EDITAR PRODUCTO */}
      <Dialog
        fullWidth
        maxWidth="xs"
        open={dialogEditar}
        onClose={handleCloseEditar}
      >
        {productoSeleccionado && (
          <EditarProducto
            producto={productoSeleccionado}
            handleClose={handleCloseEditar}
            onProductoEditado={handleProductoEditado}
          />
        )}
      </Dialog>
    </>
  );
}

export default ProductosReporte;
